function isCustomPatchMaterial(material) {
  return ['878', '678', 'W12', 'U25','black_red_white','red_white_black','white_red_black','black-anthracite','black-fluo_red','black-fuxia','anthracite_white','anthracite_fuxia_aqua_green'].indexOf(material) === -1;
}

export default function (materials) {
  return Object.keys(materials)
    .filter(isCustomPatchMaterial)
    .reduce((carry, material) => {
      carry[material] = materials[material];
      return carry;
    }, {});
}



// WEBPACK FOOTER //
// ./src/utils/filterCustomPatchMaterial.js